// Vaidvana brand palette — the single source of truth for color across the app.
// MUI palette slots map 1:1 to the brand tokens so components reference
// `primary.main`, `text.secondary`, `divider`, etc. instead of literal hex.
//
//   --color-primary        -> primary.main
//   --color-primary-hover  -> primary.dark
//   --color-primary-soft   -> primary.light
//   --color-accent         -> secondary.main      (saffron)
//   --color-accent-hover   -> secondary.dark
//   --color-text           -> text.primary
//   --color-text-muted     -> text.secondary
//   --color-background     -> background.default   (bone)
//   --color-surface        -> background.paper
//   --color-border         -> divider
//   --color-error          -> error.main           (terracotta)
export const palette = {
  primary: {
    main: '#0F4C3A', // Deep forest green
    light: '#7BA88D', // Warm sage (primary-soft)
    dark: '#0A3829', // Primary hover
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#D4A24C', // Saffron gold (accent)
    light: '#E2BD7E',
    dark: '#B8893C', // Accent hover
    contrastText: '#1A1F1C',
  },
  success: {
    main: '#0F4C3A',
    light: '#7BA88D',
    dark: '#0A3829',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#D4A24C',
    light: '#E2BD7E',
    dark: '#B8893C',
  },
  error: {
    main: '#C45A3F', // Terracotta
    light: '#D88068',
    dark: '#A2462F',
  },
  info: {
    main: '#0F4C3A',
    light: '#7BA88D',
    dark: '#0A3829',
  },
  background: {
    default: '#FAF7F2', // Bone
    paper: '#FFFFFF', // Surface
  },
  text: {
    primary: '#1A1F1C', // Charcoal
    secondary: '#5C6660', // Muted
    disabled: '#9AA39D',
  },
  divider: '#E5E0D8', // Border
  grey: {
    50: '#FAF7F2',
    100: '#F4F0E9',
    200: '#E5E0D8',
    300: '#D5CEC2',
    400: '#9AA39D',
    500: '#5C6660',
    600: '#454D48',
    700: '#333A36',
    800: '#252B28',
    900: '#1A1F1C',
  },
  // Clinical-specific colors (retained for dashboard UI until the
  // step-by-step whole-app rebrand reaches those screens).
  clinical: {
    consultation: '#0F4C3A',
    homeVisit: '#7BA88D',
    videoConsult: '#0F4C3A',
    therapy: '#0F4C3A',
    emergency: '#C45A3F',
  },
} as const;

export type PaletteType = typeof palette;
